import { createContext, useState, useContext, PropsWithChildren } from 'react';

type GuestApplyForMeterContextReturnValue = {
  email: string;
  setEmail: (email: string) => void;
};

export const GuestApplyForMeterContext = createContext(
  {} as GuestApplyForMeterContextReturnValue
);

export const GuestApplyForMeterContextProvider = ({
  children,
}: PropsWithChildren) => {
  const [email, setEmail] = useState('');

  return (
    <GuestApplyForMeterContext.Provider value={{ email, setEmail }}>
      {children}
    </GuestApplyForMeterContext.Provider>
  );
};

export const useGuestApplyForMeterContext = () => {
  const context = useContext(GuestApplyForMeterContext);
  if (context === undefined) {
    throw new Error(
      'useGuestApplyForMeterContext must be used within a GuestApplyForMeterContextProvider'
    );
  }
  return context;
};
